import { useContext, useEffect, useRef, useState } from "react";
import SearchModalComponent from "../Componets/SearchModal";
import Context from "../Context";
import { getSiteSocial } from "../views/utilities/ApiCalls";
import Nav from "./Nav";
import NavAuthenticated from "./NavAuthenticated";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NewNav } from "./NewNav";
import { NewAuthNav } from "./NewAuthNav";
import { useModel } from "../hooks/modelcontex";
import styled from "styled-components";
import BottomNav from "./BottomNav";
export default function Layout(props) {
  const { t } = useTranslation();
  const { state, dispatch } = useContext(Context);
  const [facebook, setFacebook] = useState(null);
  const [twitter, setTwitter] = useState(null);
  const [linkedin, setLinkedin] = useState(null);
  const [instagram, setInstagram] = useState(null);
  const [youtube, setYoutube] = useState(null);
  const { SetPopup, popup } = useModel();
  const navWrapperRef = useRef(null);
  const [homeNavHeight, setHomeNavHeight] = useState(0);

  useEffect(() => {
    getSiteSocial().then((response) => {
      response.data.map((item) => {
        if (item.title.toUpperCase() === "facebook".toUpperCase())
          setFacebook(item);
        if (item.title.toUpperCase() === "twitter".toUpperCase())
          setTwitter(item);
        if (item.title.toUpperCase() === "linkedin".toUpperCase())
          setLinkedin(item);
        if (item.title.toUpperCase() === "instagram".toUpperCase())
          setInstagram(item);
        if (item.title.toUpperCase() === "youtube".toUpperCase())
          setYoutube(item);
      });
    });
  }, []);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const measureNav = () => {
      const height = navWrapperRef.current?.getBoundingClientRect?.().height || 0;
      setHomeNavHeight(height);
    };

    measureNav();
    window.addEventListener("resize", measureNav);
    return () => {
      window.removeEventListener("resize", measureNav);
    };
  }, [state.token]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--home-fixed-nav-height",
      `${homeNavHeight}px`,
    );
  }, [homeNavHeight]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--bottom-nav-height",
      windowSize.width < 768 ? "75px" : "0px",
    );
  }, [windowSize.width]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${windowSize.height}px`,
    );
  }, [windowSize.height]);

  // Ensure body overflow is always reset when auth state changes.
  // NewAuthNav manages overflow for authenticated users (popup menus on mobile).
  // When logged out (NewNav shown), body overflow must be explicitly cleared so
  // Bootstrap modals, SearchModal, or any other component that sets
  // document.body.style.overflow = "hidden" doesn't permanently block scrolling.
  useEffect(() => {
    if (!state.token) {
      document.body.style.overflow = "auto";
      document.body.classList.remove("modal-open");
    }
  }, [state.token]);

  return (
    <>
      <div
        ref={navWrapperRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
        }}
      >
        {state.token ? <NewAuthNav /> : <NewNav />}
      </div>

      <Root $homeNavOffset={homeNavHeight}>
        <div className={popup && windowSize.width < 700 && "opacity"}>
          {props.children}
        </div>
      </Root>
      {windowSize.width < 768 && <BottomNav />}
      <section className="" style={{ backgroundColor: "black" }}>
        <div className="container bg-transparent">
          <div
            className="footerContent"
            style={{
              display: "flex",
              justifyContent: "center",
              color: "#fff",
              padding: 5,
            }}
          >
            © 2024 StoryTent. {t("FooterContent")}
          </div>
        </div>
      </section>

      <SearchModalComponent />
    </>
  );
}

const Root = styled.div`
  background-color: var(--color-background);
  min-height: 100vh;
  /* Use border color for grid lines so they adapt to theme (light/dark) */
  background-image: linear-gradient(var(--color-border) 1px, transparent 1px);

  /* Hide grid lines in dark mode */
  [data-theme='dark'] &, .dark-mode &, .dark & {
    background-image: linear-gradient(var(--color-border) 0px, transparent 1px);
  }

  background-size: 100% 25px;
  padding-bottom: 0;
  padding-top: ${({ $homeNavOffset }) => `${$homeNavOffset || 0}px`};

  @media (max-width: 767px) {
    padding-bottom: calc(110px + env(safe-area-inset-bottom, 0px));
  }
  /* overflow: hidden; Removed to allow sticky elements to work if needed, or keep if scrollbars issue */

  .opacity {
    opacity: 0.5;
  }
  .footerContent {
    display: flex;
    justify-content: center;
  }
`;
